import ApiService from '../apiservice'

export default class FinanceiroService extends ApiService {
  constructor() {
    super('/lancamentos')
  }

  listarMeses() {
    return this.get('/meses');
  }

  cadastrarLancamento(lancamento) {
    return this.post('/',lancamento);
  }

  cadastrarLancamentoParcelas(parcelas, recorrencia, lancamento) {
    return this.post(`/parcelada?parcelas=${parcelas}&recorrencia=${recorrencia}`,lancamento);
  }

  consultarLancamento(codigo) {
    return this.get(`/${codigo}`);
  }

  depesasPorMes(empresa) {
    return this.get(`/lancamentosDespesaDatas?empresa=${empresa}`);
  }

  receitasPorMes(empresa) {
    return this.get(`/lancamentosReceitaDatas?empresa=${empresa}`);
  }

  lancamentosPorTipoPeriodo(empresa, dataInicial, dataFinal, tipo) {
    return this.get(`/lancamentosPorTipoPeriodo?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipo=${tipo}`);
  }

  lancamentosPorTipoDescricaoPeriodo(empresa, dataInicial, dataFinal, tipoCodigo, tipo, situacao) {
    let params = `/lancamentosPorTipoDescricaoPeriodo?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipoCodigo=${tipoCodigo}&tipo=${tipo}&situacao=${situacao}`
    return this.get(params);
  }

  lancamentoGrafico(empresa, dataInicial, dataFinal, tipo) {
    return this.get(`/lancamentosGrafico?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipo=${tipo}`);
  }

  pagarOuCancelarLancamento(lancamento) {
    return this.put(`/pagarOuCancelarLancamento/${lancamento.codigo}`, lancamento);
  }

  pagarOuCancelarLancamentoIndividual(lancamento) {
    console.log('Lançamento', lancamento);
    return this.put(`/pagarOuCancelarLancamentoIndividual/${lancamento.codigo}`, lancamento);
  }

  reabrirLancamento(lancamento) {
    return this.put(`/reabrirLancamento/${lancamento.codigo}`, lancamento);
  }

  relatorioDetalhado(empresa, dataInicial, dataFinal, tipo, categoria, situacao, codigo, processo, descricao, classificacao, ordem) {
    let params = `/relatorioDetalhado?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipo=${tipo}&categoria=${categoria}&situacao=${situacao}&codigo=${codigo}&processo=${processo}&descricao=${descricao}&classificacao=${classificacao}&ordem=${ordem}`
    console.log('O parâmetro', params);
    return this.get(params);
  }

  relatorioResumido(empresa, dataInicial, dataFinal, situacao, relatorio) {
    return this.get(`/relatorioResumido?empresa=${empresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}
                                                &situacao=${situacao}&relatorio=${relatorio}`);
  }

  vencendoAmanha(empresa) {
    return this.get(`/vencendoAmanha/${empresa}`);
  }

  vencendoHoje(empresa) {
    return this.get(`/vencendoHoje/${empresa}`);
  }

  pendente(empresa) {
    return this.get(`/pendente/${empresa}`);
  }

  detalharPendentes(empresa, tipoCodigo, tipo) {
    let params = `/detalharPendentes?empresa=${empresa}`;

    if(tipoCodigo != null) {
      params = `${params}&tipoCodigo=${tipoCodigo}`;
    }

    if(tipo != null) {
      params = `${params}&tipo=${tipo}`;
    }

    return this.get(params);
  }

  detalharVencendoHoje(empresa, tipoCodigo, tipo) {
    let params = `/detalharVencendoHoje?empresa=${empresa}`;

    if(tipoCodigo != null) {
      params = `${params}&tipoCodigo=${tipoCodigo}`;
    }

    if(tipo != null) {
      params = `${params}&tipo=${tipo}`;
    }

    return this.get(params);
  }
}